/**
 * Ochrana před double klikem na submit tlačítko
 * Stačí přidat na form atribut data-prevent-double-form-submit
 * První část je pro formuláře bez ajaxu druhá pro AJAX formuláře
 */

export default function () {
	document.querySelectorAll('[data-prevent-double-form-submit]').forEach((form) => {
		form.addEventListener('submit', (e) => {
			if (Nette.validateForm(e.currentTarget, true)) {
				if (e.submitter.dataset.submitted === 'true') {
					e.stopPropagation();
					e.preventDefault();
					return;
				}

				// Je potřeba si předat stav odeslání přes data atribut.
				// Nastavit atribut disabled na tlačítko není řešení,
				// protože se poté neodešle informace, kterým tlačítkem byl formulář odeslán
				// a Nette neví jaký callback má při zpracování použít - pokud je použito $button->onClick[] ...
				e.submitter.dataset.submitted = true;

				// po 6 vteřinách atribut zrušíme, aby mohl uživatel případně odeslat formulář znovu
				setTimeout(() => e.submitter.removeAttribute('data-submitted'), 6000);
			}
		});
	});
}
